import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaGoogle } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import logo from '../logo.svg';
import config from './config.json';
import Header from './Header';
import './UploadSection.css';
import img from './signup.png';

async function login(username, password) {
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: username,
          password: password,
          product_name: "MAYAMAYA_LITE"
        }),
      });
  
      if (response.ok) {
        const data = await response.json();
        if (data.access_token) {
          localStorage.setItem("access_token", data.access_token);
          localStorage.setItem("email", username);
          return data; // Login successful
        } else {
          return null;
        }
      } else if (response.status === 401) {
        return null;
      } else {
        throw new Error(`Login failed: ${response.statusText}`);
      }
    } catch (error) {
      return null;
    }
  }
  
  // New function to handle forgot password
  async function handleForgotPassword(email) {
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/api/user/send-mail/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          suite_product: "RESUME-FORENSICS",
        }),
      });
  
      const data = await response.json();
      return data; // Return the response data
    } catch (error) {
      console.error("Error sending forgot password email:", error);
      return null;
    }
  }

function Login({ name, setIsRegisterModalOpen, setIsModalOpen, isModalOpen, isRegisterModalOpen, setIsLoggedIn, setUsername, setAccessKey, remainingCredits }) {
  const [loginUsername, setLoginUsername] = useState("");
  const [isLoggedIn, setIsLoggedInLocal] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [username, setUsernameLocal] = useState(""); // For login
  const navigate = useNavigate();

  const handleLogin = async () => {
    const response = await fetch(`${config.AUTH_BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: username,
        password: password,
        product_name: "MAYAMAYA_LITE",
      }),
    });
  
    if (response.ok) {
      const data = await response.json();
      if (data.access_token) {
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("email", username);
        setIsLoggedIn(true);
        setIsLoggedInLocal(true);
        setUsername(username);
        setAccessKey(data.access_token);
        setIsModalOpen(false);
        navigate("/dashboard");
      }
    else if (data.status === 403) {
      // Redirect to verification email page with email in URL
      navigate(`/email-sent?email=${encodeURIComponent(username)}`);
    } else {
      triggerPopup("Login failed");
    }}
  };
  

  const handleGoogleLogin = async () => {
    try {
      const response = await fetch(`${config.AUTH_BASE_URL}/authorize/google/signin`, {
        headers: {
          "Access-Control-Allow-Origin": "* ",
          "Access-Control-Allow-Headers": "Content-Type",
        },
      });
      const data = await response.json();
      if (response.ok && data.data && data.data.auth_url) {
        window.location.assign(data.data.auth_url);
      } else {
        triggerPopup("Google login failed");
      }
    } catch (error) {
      console.error("Error during Google login:", error);
      triggerPopup("An error occurred during Google login");
    }
  };

  const handleForgotPasswordClick = async () => {
    if (!username) {
      triggerPopup("Please enter your email address.")
      return
    }

    const response = await handleForgotPassword(username) // Use username as email
    if (response) {
      triggerPopup("Forgot password email sent! Check your inbox.")
      setUsername("") // Clear the email input
    } else {
      triggerPopup("Failed to send forgot password email.")
    }
  }

    // Toggle password visibility
const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setPopupMessage(""); // Optionally clear the popup message if needed
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };
  
  const triggerPopup = (message) => {
    setPopupMessage(message);
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };

  return (
    <div className="flex min-h-screen">   
    <Header
      name={name}
      setIsLoggedIn={setIsLoggedIn}
      setUsername={setUsername}
      setAccessKey={setAccessKey}
      remainingCredits={remainingCredits}
      setIsRegisterModalOpen={setIsRegisterModalOpen}
      setIsModalOpen={setIsModalOpen}
      isModalOpen={isModalOpen}
      isRegisterModalOpen={isRegisterModalOpen}
    />   
      <div className="modal-content">
              <div className="modal-left">
              <img src={img} alt='signup image' className="signup-image" />
              <div style={{width: "100%"}}>
        <h1 className="headline-unique">Acquire, Engage and Retain Talent With <span style={{color: "#672024", fontStyle: "italic"}}>MayaMaya Lite</span></h1>
        <p className="subheading-unique">With MayaMaya Lite you can perform AI-driven resume analysis and intelligent matching for perfect job fits, ensuring you never miss out on top talent.</p>
      </div>
              </div>
              <div className="modal-right">
                <h3 style={{fontWeight: "600", marginBottom: "20px", letterSpacing: "1.2px"}}>LOGIN</h3>
                <label style={{fontWeight: "600", marginBottom: "-15px", letterSpacing: "1.5px"}}>EMAIL</label>
                <input
                  type="text"
                  placeholder="@example.com"
                  value={username}
                  onChange={(e) => setUsernameLocal(e.target.value)}
                  onKeyDown={handleKeyPress}
                />
                <label style={{fontWeight: "600", marginBottom: "-15px", letterSpacing: "1.5px"}}>PASSWORD</label>
                <div className="password-input">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleKeyPress}
                  />
                  <span onClick={toggleShowPassword} className="eye-icon">
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <div>
                  <p style={{ marginTop: '15px', fontSize: '14px', color: "#555" }}><span onClick={handleForgotPasswordClick} style={{ cursor: "pointer", color: "#333" }}>Forgot Password?</span></p>
                </div>
                <button className="modal-btn" onClick={handleLogin}>Login</button>
                
                <p style={{ marginTop: '15px', fontSize: '14px', color: "#555" }}>
                  Don't have an account?
                  <a
                    href="/signup"
                    style={{ color: '#5b161a', textDecoration: 'none' }}
                    onMouseOver={(e) => (e.currentTarget.style.textDecoration = 'underline')}
                    onMouseOut={(e) => (e.currentTarget.style.textDecoration = 'none')}
                  >
                    <strong> Sign Up</strong>
                  </a>
                </p>
                <div class="divider">
                <span>OR</span>
                </div>
                <div className="google-login-container" style={{ marginTop: "0px", display: "flex", justifyContent: "center" }}>
                  <button
                    onClick={handleGoogleLogin}
                    className="modal-btn">
                    <FaGoogle style={{paddingTop: "5px", marginRight: "10px"}}/>
                    Login with Google
                  </button>
                </div>
              </div>
            </div>

            {showPopup && (
          <div>
            <div className="overlay" onClick={handleClosePopup}></div>
            <div className="popup">
              <button className="close-btn" onClick={handleClosePopup}>×</button>
              {popupMessage}
            </div>
          </div>
        )}
      <footer className="footer">
        <p>MayaMaya Suite of Products - MayaMaya Lite</p>
      </footer>
    </div>
  );
}

export default Login;

